import { render, staticRenderFns } from "./OStatus.vue?vue&type=template&id=69a8e33a&scoped=true"
import script from "./OStatus.vue?vue&type=script&lang=js"
export * from "./OStatus.vue?vue&type=script&lang=js"
import style0 from "./OStatus.vue?vue&type=style&index=0&id=69a8e33a&prod&scoped=true&lang=css"
import style1 from "./OStatus.vue?vue&type=style&index=1&id=69a8e33a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a8e33a",
  null
  
)

export default component.exports